import { FC, ReactElement, ReactNode } from 'react';

interface IMenuItemProps {
  icon: ReactElement;
  title: string;
  active?: boolean;
  showSidebar?: boolean;
  children?: ReactNode[];
  onClick: () => void;
}

const MenuItem: FC<IMenuItemProps> = ({
  icon,
  title,
  children,
  active = false,
  showSidebar = false,
  onClick,
}) => {
  return (
    <div className="relative py-[5px]">
      <div
        className={`w-[39px] h-[39px] flex items-center justify-center bg-[#211F24] rounded-[16px] cursor-pointer  ${active ? 'fill-[white]' : ' fill-[#959595]'}`}
        onClick={() => onClick()}
      >
        {icon}
      </div>
      <div>
        {showSidebar ? (
          <div
            className={`first-letter:uppercase absolute left-[49px] top-[11px] ml-[5px] text-xl font-medium cursor-pointer ${active ? 'text-[white]' : undefined}`}
            onClick={() => onClick()}
          >
            {title}
          </div>
        ) : null}

        {showSidebar && active && children?.length ? (
          <div className="sidebar-item__sub_items my-[15px]">{children}</div>
        ) : null}
      </div>
    </div>
  );
};

export default MenuItem;
